import { PerformanceReturn } from '@ddt-web/domain';

import { PerformanceReturnBuilder } from '../builders/performance-return.builder';

export class PerformanceReturnDirector {
	public construct(portfolioJson: any, builder: PerformanceReturnBuilder = new PerformanceReturnBuilder()): PerformanceReturn {
		if (portfolioJson.portfolioType === 'MODEL_PORTFOLIO') {
			if (portfolioJson.modelPortfolio) {
				const monthEndPerf =
					(portfolioJson.modelPortfolio.monthlyPerformanceByCurrencyAndTypeMap &&
						portfolioJson.modelPortfolio.monthlyPerformanceByCurrencyAndTypeMap.USD &&
						portfolioJson.modelPortfolio.monthlyPerformanceByCurrencyAndTypeMap.USD.FUND_NAV_SOURCED) ||
					{};
				const chartData = portfolioJson.returns && portfolioJson.returns.performanceChart ? portfolioJson.returns.performanceChart : [];
				const benchmarkPerf =
					(portfolioJson.modelPortfolio.monthlyPerformanceByCurrencyAndTypeMap &&
						portfolioJson.modelPortfolio.monthlyPerformanceByCurrencyAndTypeMap.USD &&
						portfolioJson.modelPortfolio.monthlyPerformanceByCurrencyAndTypeMap.USD.BENCHMARK_BENCHMARK_SOURCED) ||
					{};
				const benchmarkName =
					(portfolioJson.modelPortfolio.relatedProductsByCodeMap &&
						portfolioJson.modelPortfolio.relatedProductsByCodeMap.PERF_BENCH[0] &&
						portfolioJson.modelPortfolio.relatedProductsByCodeMap.PERF_BENCH[0].relPortfolioName) ||
					'';

				return builder
					.setUniqueId(portfolioJson.portfolioId ? portfolioJson.portfolioId.toString() : portfolioJson.id ? portfolioJson.id.toString() : null)
					.setHasReturnsData(monthEndPerf)
					.setAsOfDate(monthEndPerf.asOfDate)
					.setChartData(chartData)
					.setFiveYear(monthEndPerf.fiveYearAnnualized)
					.setLastMonth(monthEndPerf.oneMonth)
					.setLastQuarter(monthEndPerf.threeMonth)
					.setOneYear(monthEndPerf.oneYearAnnualized)
					.setSinceInception(monthEndPerf.sinceInceptionAnnualized)
					.setThreeYear(monthEndPerf.threeYearAnnualized)
					.setYearToDate(monthEndPerf.yearToDate)
					.setBenchmarkName(benchmarkName)
					.setBenchmarkLastMonth(benchmarkPerf.oneMonth)
					.setBenchmarkLastQuarter(benchmarkPerf.threeMonth)
					.setBenchmarkOneYear(benchmarkPerf.oneYear)
					.setBenchmarkThreeYear(benchmarkPerf.threeYear)
					.setBenchmarkFiveYear(benchmarkPerf.fiveYear)
					.setBenchmarkYearToDate(benchmarkPerf.yearToDate)
					.setBenchmarkSinceInception(benchmarkPerf.sinceInceptionAnnualized)
					.build();
			}
		} else {
			if (portfolioJson.returns && portfolioJson.returns.performanceChart) {
				const monthEndPerf = (portfolioJson.returns && portfolioJson.returns.monthEndPerf) || {};

				return builder
					.setUniqueId(portfolioJson.uniqueId ? portfolioJson.uniqueId.toString() : null)
					.setHasReturnsData(monthEndPerf)
					.setAsOfDate(monthEndPerf.asOfDate)
					.setChartData(portfolioJson.returns.performanceChart)
					.setFiveYear(monthEndPerf.fiveYearAnnualized ? monthEndPerf.fiveYearAnnualized * 100 : null)
					.setLastMonth(monthEndPerf.oneMonth ? monthEndPerf.oneMonth * 100 : null)
					.setLastQuarter(monthEndPerf.threeMonth ? monthEndPerf.threeMonth * 100 : null)
					.setOneYear(monthEndPerf.oneYearAnnualized ? monthEndPerf.oneYearAnnualized * 100 : null)
					.setSinceInception(monthEndPerf.sinceStartDate ? monthEndPerf.sinceStartDate * 100 : null)
					.setThreeYear(monthEndPerf.threeYearAnnualized ? monthEndPerf.threeYearAnnualized * 100 : null)
					.setYearToDate(monthEndPerf.yearToDate ? monthEndPerf.yearToDate * 100 : null)
					.build();
			}
		}
		return null;
	}
}
